import { useEffect } from 'react'

import { useAppDispatch } from 'src/Hooks/redux'
import { useCustomSearchParams } from 'src/Hooks/useCustomSearchParams'
import { refetchUsersMe } from 'src/Redux/userInfoApi'
import {
  useApplyInvitedBonusMutation,
  useSignUpFirstPromoterMutation,
} from 'src/Redux/referralBonusApi'
import {
  clearPendingReferralCodes,
  readPendingReferralCodes,
} from 'src/Utils/pendingReferralCodes'

import { getTokenFromUrl } from './helpers'

export const useApplyPendingReferralBonuses = (): null => {
  const dispatch = useAppDispatch()
  const { search } = useCustomSearchParams()
  const [applyInvitedBonus] = useApplyInvitedBonusMutation()
  const [signUpFirstPromoter] = useSignUpFirstPromoterMutation()

  const token = getTokenFromUrl(search)

  useEffect(() => {
    if (!token) {
      return
    }

    const { internalReferralCode, referralCode } = readPendingReferralCodes()

    if (!internalReferralCode && !referralCode) {
      return
    }

    const pendingRequests: Promise<unknown>[] = []

    if (internalReferralCode) {
      pendingRequests.push(
        applyInvitedBonus({ internalReferralCode, token }).unwrap(),
      )
    }
    if (referralCode) {
      pendingRequests.push(
        signUpFirstPromoter({ referralCode, token }).unwrap(),
      )
    }

    void Promise.allSettled(pendingRequests).then(() => {
      void dispatch(refetchUsersMe())
    })

    clearPendingReferralCodes()
  }, [token, applyInvitedBonus, signUpFirstPromoter, dispatch])

  return null
}
